export default __webpack_public_path__ + "static/media/project-icon.4cc54e94.svg";